import React from 'react';

/**
 * 处理富文本内容，支持{br}换行标记和HTML标签
 * @param val 输入的文本值
 * @returns 处理后的React节点
 */
export const processRichText = (val: any): React.ReactNode => {
  if (typeof val !== 'string') return val;
  const str = val;
  
  // 处理{br}换行标记，无论是否包含HTML
  if (str.includes('{br}')) {
    const parts = str.split('{br}');
    return parts.map((item, index) => {
      return React.createElement(
        React.Fragment,
        { key: index },
        // 使用dangerouslySetInnerHTML处理HTML内容
        React.createElement('span', { dangerouslySetInnerHTML: { __html: item } }),
        index !== parts.length - 1 && React.createElement('br', null)
      );
    });
  }
  
  // 如果包含HTML标签，直接返回字符串，让dangerouslySetInnerHTML处理
  if (/<[^>]+>/i.test(str)) {
    return str;
  }
  
  return str;
};

/**
 * 安全的formatMessage包装器，自动处理富文本
 * @param formatMessage react-intl的formatMessage函数
 * @param descriptor 消息描述符
 * @param values 消息变量
 * @returns 处理后的React节点
 */
export const safeFormatMessage = (
  formatMessage: (descriptor: any, values?: any) => string,
  descriptor: any,
  values?: any
): React.ReactNode => {
  const result = formatMessage(descriptor, values);
  return processRichText(result);
};

/**
 * 创建增强的formatMessage函数，自动处理富文本
 * @param formatMessage react-intl的formatMessage函数
 * @returns 增强的formatMessage函数
 */
export const createEnhancedFormatMessage = (formatMessage: (descriptor: any, values?: any) => string) => {
  return (descriptor: any, values?: any): React.ReactNode => {
    return safeFormatMessage(formatMessage, descriptor, values);
  };
};